function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { _Object$defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _Symbol$iterator from "@babel/runtime-corejs3/core-js-stable/symbol/iterator";
import get from 'get-value';

var defaultGetter = function defaultGetter(prop) {
  return function (state) {
    return get(state, prop);
  };
};

var simpleMappers = function simpleMappers(props, getter) {
  return function () {
    var slices = _concatInstanceProperty([]).apply([], props);

    var state = this[this.REDUX_VUEX_STORE].getState();
    this.REDUX_VUEX_BINDINGS = _reduceInstanceProperty(slices).call(slices, function (result, prop) {
      return _Object$assign({}, result, _defineProperty({}, prop, getter(prop)));
    }, this.REDUX_VUEX_BINDINGS || {});
    return _reduceInstanceProperty(slices).call(slices, function (result, prop) {
      return _Object$assign({}, result, _defineProperty({}, prop, getter(prop)(state)));
    }, {});
  };
};

var objectMappers = function objectMappers(obj, fallbackGetter) {
  return function () {
    var _this = this;

    var slices = _Object$keys(obj);

    var state = this[this.REDUX_VUEX_STORE].getState();
    this.REDUX_VUEX_BINDINGS = _reduceInstanceProperty(slices).call(slices, function (result, prop) {
      var _context;

      return _Object$assign({}, result, _defineProperty({}, prop, typeof obj[prop] === 'function' ? _bindInstanceProperty(_context = obj[prop]).call(_context, _this) : fallbackGetter(obj[prop])));
    }, this.REDUX_VUEX_BINDINGS || {});
    return _reduceInstanceProperty(slices).call(slices, function (result, prop) {
      return _Object$assign({}, result, _defineProperty({}, prop, typeof obj[prop] === 'function' ? obj[prop].call(_this, state) : fallbackGetter(obj[prop])(state)));
    }, {});
  };
};
/**
* maps redux state to data attributes
* @param {*} props array / strings / mapper object
*/


export default (function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }

  var obj = props[0];
  /**
   * mapState({ foo: 'bar', foo: state => state('bar') })
   */

  if (!_Array$isArray(obj) && _typeof(obj) === 'object') {
    return objectMappers(obj, defaultGetter);
  }
  /**
   * mapState(['foo', 'bar', 'baz']) \\ mapState('foo', 'bar', 'baz')
   */


  return simpleMappers(props, defaultGetter);
});